export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="57" height="45" viewBox="0 0 57 45" fill="none">
            <path
                d="M7.89784 43.1146L5.25681 20.2256C5.15766 19.3664 6.12238 18.795 6.82823 19.295L17 26.5L28.1576 10.2285C28.5596 9.64226 29.4277 9.65081 29.818 10.2448L40.5 26.5L50.1483 19.3687C50.8516 18.8488 51.8363 19.4186 51.7361 20.2875L49.1022 43.1146C49.0439 43.6192 48.6167 44 48.1087 44H8.89125C8.38331 44 7.95606 43.6192 7.89784 43.1146Z"
                fill="#FDF6E8"
            />
            <path
                d="M17 26.5L28.4095 34.5817C28.7619 34.8313 29.2347 34.8266 29.5819 34.5699L40.5 26.5M17 26.5L6.82823 19.295C6.12238 18.795 5.15766 19.3664 5.25681 20.2256L7.89784 43.1146C7.95606 43.6192 8.38331 44 8.89125 44H48.1087C48.6167 44 49.0439 43.6192 49.1022 43.1146L51.7361 20.2875C51.8363 19.4186 50.8516 18.8488 50.1483 19.3687L40.5 26.5M17 26.5L28.1576 10.2285C28.5596 9.64226 29.4277 9.65081 29.818 10.2448L40.5 26.5"
                stroke="url(#paint0_linear_567_6523)"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <circle cx="5" cy="15" r="4" stroke="url(#paint1_linear_567_6523)" strokeWidth="2" />
            <circle cx="29" cy="5" r="4" stroke="#F1CC8A" strokeWidth="2" />
            <circle cx="52" cy="15" r="4" stroke="url(#paint2_linear_567_6523)" strokeWidth="2" />
            <defs>
                <linearGradient id="paint0_linear_567_6523" x1="28.5" y1="9" x2="28.5" y2="44" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F1CA88" />
                    <stop offset="1" stopColor="#C7914F" />
                </linearGradient>
                <linearGradient id="paint1_linear_567_6523" x1="5" y1="10" x2="5" y2="20" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F1CC8A" />
                    <stop offset="1" stopColor="#E3B775" />
                </linearGradient>
                <linearGradient id="paint2_linear_567_6523" x1="52" y1="10" x2="52" y2="20" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F1CC8A" />
                    <stop offset="1" stopColor="#E4B976" />
                </linearGradient>
            </defs>
        </svg>
    );
}
